export const SELECT_GUIDE_STAGES = {
    CHOOSE_STAGE: "CHOOSE_STAGE",
    EXISTING_GUIDE: "EXISTING_GUIDE",
    NEW_GUIDE: "NEW_GUIDE",
};
